const isFeatureFlagEnabled = (flagName: string) => {
  let isFlagEnabled = process.env[`REACT_APP_FEATUREFLAG_${flagName}`] == 'true'
  const urlSearch = new URLSearchParams(window.location.search)
  const flagParam = urlSearch.get(flagName)

  if (flagParam) {
    isFlagEnabled = flagParam == 'true'
  }

  return isFlagEnabled
}

export const TEST_REPORT_NUMBER_COLUMN_VISIBLE = isFeatureFlagEnabled(
  'TEST_REPORT_NUMBER_COLUMN_VISIBLE'
)

export const ENABLED_MILESTONE_MANUAL_STATUS_UPDATE = isFeatureFlagEnabled(
  'MILESTONE_MANUAL_STATUS_UPDATE'
)

export const ENABLED_DM_INTEGRATION = isFeatureFlagEnabled('DM_INTEGRATION')

export const ECD_ALIGN_DYNAMIC = isFeatureFlagEnabled('ECD_ALIGN_DYNAMIC')
